/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable jsx-a11y/media-has-caption */
import { FC, useState, useEffect } from 'react';
import { GetServerSideProps } from 'next';
import { ParsedUrlQuery } from 'querystring';
import dayjs from 'dayjs';
import dynamic from 'next/dynamic';
import { Asset } from '@sendspark/js-api-sdk';
import {
  EnvConfig,
  Campaign,
  CampaignStyle,
  CampaignCreator,
  CampaignMetaVideo,
  CampaignMessage,
  DynamicVariables,
} from '@interfaces';
import { isMobile } from '@utils';
import {
  createVideoRequestAsset,
  getVideoRequest,
  updateVideoRequest,
} from '@api-v2/request';
import Layout from '@components/RequestProject/Layout';
import RenderIf from '@components/RequestProject/RenderIf';
import {
  useSegmentTracker,
  useViralLink,
  useCreateIntegrationsByPosition,
} from '@hooks';
import { environmentsConfig } from '@config';
import RequestMediaPermission from '@components/RequestProject/RequestScenes/RequestMediaPermission';
import NotSupported from '@components/RequestProject/NotSupported';
import { SegmentEvents } from '@constants/SegementEvents';
import WhiteLabel404Page from '@components/RequestProject/WhiteLabel404Page';
import { uploadAssetToMux } from '@services/mux';
import {
  RecorderProvider,
  useRecorderContext,
} from '@recorder/context/recorderContext';
import { useVisitorId } from '@hooks/lib/useVisitorId';
import { paramsValidator } from '@constants/paramsValidator';
import { RequestStatus } from '@constants/record';
import { getCampaign } from '@api-v2/campaigns';
import { RECORDING_CODECS_BY_OS } from '@recorder/constants';
import { RecordingCodecsPropsByOS } from '@recorder/context/recorderReducer';
import ShareWrappers from '@components/ShareWrappers';

const Initial = dynamic(
  () => import('@components/RequestProject/RequestScenes/Initial'),
  {
    ssr: false,
  }
);

const Recorder = dynamic(() => import('@recorder/index'));

const TextContainer = dynamic(
  () => import('@components/RequestProject/TextContainer'),
  {
    ssr: false,
  }
);

const RecorderSelectionScreen = dynamic(
  () =>
    import('@components/RequestProject/RequestScenes/RecorderSelectionScreen'),
  {
    ssr: false,
  }
);

interface RequestVideoServerProps {
  campaign?: Campaign;
  requestId?: string;
  env?: EnvConfig;
  custom404?: boolean;
}

interface PlayerProps {
  video: CampaignMetaVideo;
  messages: Array<CampaignMessage>;
}

interface RequestVideoPageProps {
  campaignId: string;
  custom404?: boolean;
  domain: string;
  env: EnvConfig;
  folderId: string;
  referralCode: string;
  requestId: string;
  sendsparkBrandingEnabled: boolean;
  whiteLabelAllowed: boolean;
  style: CampaignStyle;
  workspaceName: string;
  creator: CampaignCreator;
  player: PlayerProps;
  userIntegrations: Array<any>;
  workspaceSettings: { limits: { video: { secondsLimit: number } } };
  recordingCodecsByOS: RecordingCodecsPropsByOS[];
  defaultRecordingCodecsByOs: RecordingCodecsPropsByOS[];
}

interface RequestVideoParams extends ParsedUrlQuery {
  requestId: string;
  workspaceId: string;
}

interface UploadFileArgs {
  data: File;
}

interface UploadFile {
  (args: UploadFileArgs): Promise<Asset>;
}

interface FormValues {
  fullName?: string;
  email?: string;
}

const ViewCampaign: FC<RequestVideoPageProps> = ({
  campaignId,
  creator,
  custom404,
  domain,
  env,
  folderId,
  referralCode,
  requestId,
  sendsparkBrandingEnabled,
  whiteLabelAllowed,
  style,
  workspaceName,
  player,
  userIntegrations,
  workspaceSettings,
  recordingCodecsByOS,
  defaultRecordingCodecsByOs,
}) => {
  if (custom404) {
    return <WhiteLabel404Page />;
  }
  // Posible values based on RequestStatus enum
  // 'initial' | 'recorder' | 'invalid' | 'final' | 'recording' | 'permission';
  // TODO: change string value to the enum values
  const [status, setStatus] = useState<string>(
    campaignId ? RequestStatus.INITIAL : RequestStatus.INITIAL
  );

  // Compared to Status, mode is a local state for this component,
  // Status is shared with some other components, we should move it to context
  const [mode, setMode] = useState('record');

  const [file, setFile] = useState<File | null>(null);
  const segmentTracker = useSegmentTracker(env.apiV2Url, creator.workspaceId);
  const [formData, setFormData] = useState<FormValues>();
  const [prospectTrackVariables, setProspectTrackVariables] = useState<DynamicVariables>()
  const { captureType, dispatch } = useRecorderContext();
  const pageTitle = sendsparkBrandingEnabled
    ? 'Sendspark Video Request'
    : 'Video Request';
  const {
    limits: {
      video: { secondsLimit },
    },
  } = workspaceSettings;

  useEffect(() => {
    if (userIntegrations?.length > 0) {
      useCreateIntegrationsByPosition(userIntegrations);
    }
  }, [userIntegrations?.length]);

  useEffect(() => {
    // Prevent unmounted component warning
    if (formData) {
      setStatus(RequestStatus.RECORDER);
      setProspectTrackVariables({
        email: formData?.email,
        firstname: formData?.fullName?.split(' ')[0] || '',
        lastname: formData?.fullName?.split(' ')[1] || '',
      })

    }
  }, [formData]);

  useEffect(() => {
    if (formData) {
      setStatus(RequestStatus.RECORDER);
    }
  }, [formData]);

  const visitorId = useVisitorId();

  const trackViralLink = async (url?: string) => {
    const viralLink = useViralLink({
      campaignId,
      referralCode,
      workspaceName,
      url: url || env?.sendsparkSiteUrl, // added default value here bc env variables are not working on hooks
      currentSite: 'request page',
    });
    window.open(viralLink, '_blank');
    await segmentTracker(SegmentEvents.viralLinkClick, {
      workspaceName,
      creator: creator._id,
      creatorEmail: creator.email,
      visitor: visitorId,
      source: 'Request Page',
    });
  };

  const uploadFile: UploadFile = async ({ data }) => {
    try {
      if (!folderId) throw new Error('Folder not found in campaign');

      const newAsset = await createVideoRequestAsset({
        requestId,
        folderId,
        name: data.name,
        mime: data.type,
        options: {
          baseURL: env.apiV2Url,
        },
      });

      const { asset, uploadUrl } = newAsset as {
        asset: Asset;
        uploadUrl: string;
      };

      await uploadAssetToMux(uploadUrl, data);

      return asset;
    } catch (error: any) {
      console.log('failed to upload asset', error?.message);
      throw new Error(`failed to upload asset ${error?.message}`);
    }
  };

  const handleOnSaveRecord = async (blob: Blob) => {
    const name = `Rec ${dayjs().format('MM/DD/YYYY h:mm A')}`;

    const mime = blob.type ? blob.type : 'video/mp4';

    const recordedFile = new File([blob], name, { type: mime });

    const asset  = await uploadFile({ data: recordedFile });

    const changedCampaignFields = {
      // The SDK's `Asset` exposes `id`; `_id` is kept first to preserve the existing runtime
      // precedence for any response still carrying the legacy shape.
      videoId: (asset as unknown as { _id?: string })?._id || asset?.id,
      requestInputData: {
        ...formData,
      },
    };

    // TODO: pass only request id, video id, and form data
    const { response: uploadedVideoRequest } = await updateVideoRequest(requestId, changedCampaignFields, {
      baseURL: env.apiV2Url,
    });
    await segmentTracker(SegmentEvents.videoRequestCompleted, {
      campaignId: uploadedVideoRequest?.campaignId,
      data: changedCampaignFields,
      asset,
      workspace: {
        id: creator?.workspaceId,
        name: workspaceName,
      },
      dynamicVariables: prospectTrackVariables,
    });

    setStatus(RequestStatus.FINAL);
  };

  const handleOnUpload = async (files: Array<File>) => {
    for (const selectedFile of files) {
      if (!/^video/.exec(selectedFile.type)) {
        console.log('Invalid file type.');
        // TODO: Notify the user.
        return;
      }
      if (!!navigator && isMobile()) {
        setMode('upload');
        await handleOnSaveRecord(selectedFile);
        setStatus('final');
      } else {
        setMode('upload');
        setFile(selectedFile);
        setStatus(RequestStatus.RECORDING);
      }
    }
  };

  const handleOnDecline = () => {
    segmentTracker(SegmentEvents.videoRequestCancel, {
      captureType: file ? 'Upload' : captureType,
      campaign: campaignId,
      userEmail: formData?.email,
    }) as unknown;
    if (mode === 'upload') {
      setMode('record');
      setFile(null);
      setStatus(RequestStatus.RECORDER);
    }
  };

  const handleOnManualCloseRecord = () => {
    setStatus(RequestStatus.RECORDER);
  };

  const handleOnSubmitForm = ({ fullName, email }: FormValues) => {
    segmentTracker(SegmentEvents.videoRequestFormSubmit, {
      visitor: visitorId,
      userName: fullName,
      userEmail: email,
      campaign: campaignId,
    }) as unknown;
    setFormData({
      fullName,
      email,
    });
  };

  const recorderCampaign = {
    meta: {
      video: player?.video,
      documentTitle: '',
      heading1: '',
      heading2: '',
      name: '',
      speakerName: '',
    },
    messages: player?.messages,
    style,
    sendsparkBrandingEnabled,
    creator,
    featureFlips: { hideMessageBy: false },
    hideMessageBy: false,
    folder: {
      _id: folderId,
      id: '',
      kind: '',
      name: '',
      org: '',
      users: [],
    },
    _id: campaignId,
    id: campaignId,
    workspaceName,
    workspaceLogo: style?.workspaceLogo,
    referralCode,
    requestId,
    userIntegrations,
    gapCombinedVideoPlayer: true
  };

  useEffect(() => {
    dispatch({ type: RECORDING_CODECS_BY_OS, payload: recordingCodecsByOS ?? defaultRecordingCodecsByOs })
  }, []);
  return (
    <>
      <Layout
        background={style?.background}
        domain={domain}
        sendsparkBrandingEnabled={sendsparkBrandingEnabled}
        whiteLabelAllowed={whiteLabelAllowed}
        style={style}
        title={pageTitle}
        trackViralLink={trackViralLink}
        workspaceName={workspaceName}
      >
        <NotSupported />

        <RenderIf condition={status === RequestStatus.INITIAL}>
          <Initial
            user={creator}
            campaignStyle={style}
            avatar={style?.avatar}
            submitForm={handleOnSubmitForm}
          />
        </RenderIf>

        <RenderIf condition={status === RequestStatus.RECORDER}>
          <RecorderSelectionScreen
            setStatus={setStatus}
            user={creator}
            onUpload={handleOnUpload}
            campaignStyle={style}
            workspaceName={workspaceName}
            workspaceLogo={style?.workspaceLogo}
            avatar={style?.avatar}
            env={env}
            secondsLimit={secondsLimit}
          />
        </RenderIf>

        <RenderIf condition={status === RequestStatus.PERMISSION}>
          <RequestMediaPermission setStatus={setStatus} campaignStyle={style} />
        </RenderIf>

        <RenderIf condition={status === RequestStatus.RECORDING}>
          <Recorder
            onSaveRecord={handleOnSaveRecord}
            onManualCloseRecord={handleOnManualCloseRecord}
            file={file}
            onDecline={handleOnDecline}
            campaign={recorderCampaign}
          />
        </RenderIf>

        <RenderIf condition={status === RequestStatus.FINAL}>
          <TextContainer
            user={creator}
            campaignStyle={style}
            workspaceLogo={style?.workspaceLogo}
            avatar={style?.avatar}
            trackViralLink={trackViralLink}
            sendsparkBrandingEnabled={sendsparkBrandingEnabled}
            env={env}
          />
        </RenderIf>

        <RenderIf condition={status === RequestStatus.INVALID}>
          <h1>The url is invalid!</h1>
        </RenderIf>
      </Layout>
    </>
  );
};

const ViewCampaignProvider: FC<RequestVideoPageProps> = (props) => (
  <ShareWrappers
    htmlBackground={props?.style?.background || '#E5E5E5'}
    segmentApiKey={props?.env?.segmentApiKey || ''}
    pusherKey={props?.env?.pusherKey || ''}
    pusherCluster={props?.env?.pusherCluster || ''}
  >
    <RecorderProvider>
      <ViewCampaign {...props} />
    </RecorderProvider>
  </ShareWrappers>
);

export const getServerSideProps: GetServerSideProps<
  RequestVideoServerProps,
  RequestVideoParams
> = async (ctx) => {
  const { params, req } = ctx;

  const isSendsparkDomain = req?.headers?.host?.includes('sendspark.com');
  const isDevelopment = req?.headers?.host?.includes('localhost');
  const requestId = params?.requestId;
  const paramIsValid = paramsValidator(requestId || '');

  if (!requestId || !paramIsValid) {
    return {
      notFound: true,
    };
  }

  let data;
  let settings;

  try {
    data = await getVideoRequest(requestId, {
      params: { host: req.headers.host },
    });

    settings = await getCampaign(requestId);

    // If we have a video already, remove it to avoid aspect ratio issues
    // and a bug where the video would flash on the player at the start.
    // We should fix this on the backend, this is a easy fix.
    data.player = { messages: data.player.messages };

    data.creator = {
      ...data.creator,
      workspaceId: settings?.creator?.workspaceId,
    }

  } catch (error: any) {
    if (error?.response?.status === 302) {
      return {
        redirect: {
          destination: error?.response?.data,
          permanent: false,
        },
        props: {},
      };
    }
    if (isSendsparkDomain || isDevelopment) {
      return {
        notFound: true,
      };
    }
    return {
      props: {
        custom404: true,
      },
    };
  }

  if (!data) {
    return {
      notFound: true,
    };
  }

  const {
    apiV2Url,
    apiV1Url,
    pusherKey,
    pusherCluster,
    nodeEnv,
    sendsparkSiteUrl,
    dashboardUrl,
    appUrl,
    segmentApiKey
  } = environmentsConfig;

  return {
    props: {
      ...settings,
      ...data,
      defaultRecordingCodecsByOs: JSON.parse(process.env.NEXT_PUBLIC_DEFAULT_RECORDING_CODECS_BY_OS || "[]"),
      env: {
        apiV2Url,
        apiV1Url,
        pusherKey,
        pusherCluster,
        nodeEnv,
        sendsparkSiteUrl,
        dashboardUrl,
        appUrl,
        segmentApiKey
      },
    },
  };
};

export default ViewCampaignProvider;
